import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { nav("/login"); return; }

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        // clear the hash to prevent reuse
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/login?error=google", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center">
      <Loader2 className="w-8 h-8 text-orange-500 animate-spin" />
      <div className="mt-4 text-xs uppercase tracking-[0.3em] text-zinc-500">Signing you in…</div>
    </div>
  );
}
